<!-- <app-innerspinner> </app-innerspinner> -->

<div class = "bigBoxHome">
    <div class="appPagecontent">
        <div class="contentDiv">
            <div class="contentSmallBox">
                <h3>Applications</h3>
                    <!-- First level menu -->
                    <div style="width: 340px;">
                        <div class="app-list" [class.active]="showMenu === sidebarnavItem.Title" *ngFor="let sidebarnavItem of sidebarnavItems">
                            <a (click)="redirect(sidebarnavItem.Title,sidebarnavItem.Path)">{{sidebarnavItem.Title}}</a>
                            <span>{{sidebarnavItem.Label}} </span> 
                        </div>
                    </div>
            </div>
            <div class="contentSmallBox sm" >
                <h2 style="font-family: Arial, Helvetica, sans-serif;">Guidance</h2>
                <p style="font-size: 13px;font-family: Arial, Helvetica, sans-serif;">Select from the services registered with your account. 
                    If you experience any problems, please use the 
                    <a href="http://www.ctglobal-freightaudit.com/Help.html" target="_parent">Help</a> or <a href="http://www.ctglobal-freightaudit.com/contact/technical-support/" target="_parent">Contact Us</a> page.
                </p>
            </div>
        </div>
    </div>
</div>
